import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DashboardIcon from '@mui/icons-material/Dashboard';
import { Roles } from "data/authData";

export const refundTrackerRoleAccess = (user) => {
	let roles = "VIEWER";
	const rolesArray = Roles.map((role) => role.key);

	if (user?.role?.ADMIN) {
		roles = "ADMIN";
	} else {
		Object.keys(user?.role || {}).forEach((role) => {
			if (rolesArray.includes(role)) {
				roles = role;
			}
		});
	}

	return { roles };
};

export const canDownloadRefundTracker = (role) =>
	["EDITOR", "PUBLISHER", "ADMIN"].includes(role);

export const refundTrackerServices = {
	masters: {
		name: "Refund Tracker",
		key: "refund_tracker",
		display: true,
		icon: <ReceiptLongIcon />,
		types: {
			dashboard: {
				name: "Dashboard",
				key: "dashboard",
				display: true,
				icon: <DashboardIcon />,
			},
		},
	},
};
